import { TranslationService } from '@rocheglobal/component-library-dot-com/src/services/translation';
import { useEffect, useState, useCallback } from 'react';

export function useTranslation(key: string, options: { capitalize?: boolean } = {}) {
  // pull out capitalize so that we can use it in the deps array
  const { capitalize = false } = options;

  // set the initial state to the key
  const [translation, setTranslation] = useState<string>(key);

  // wrap the translation call in useCallback so it stays stable
  const fetchTranslation = useCallback(async () => {
    let t = await TranslationService.translate(key);

    if (capitalize && t.length > 0) {
      t = t[0].toUpperCase() + t.slice(1);
    }

    setTranslation(t);
  }, [key, capitalize]);

  useEffect(() => {
    // initial load
    fetchTranslation();
  }, [fetchTranslation]);

  return translation;
}
